// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__ZZw1U","info":"PatientInfo_info__3StAv"};